import {
  useGetCurrentUserCurrencyQuery,
  CurrencyFragment,
} from "__generated__/graphql";

export interface ICurrencyPreview extends CurrencyFragment {
  prefix: string;
}
export const useCurrency = (): ICurrencyPreview | null => {
  const { data } = useGetCurrentUserCurrencyQuery();
  if (!data?.currentUser?.currency) return null;
  return {
    prefix: data.currentUser.currency
      ? data.currentUser.currency.isoCode +
        " " +
        data.currentUser.currency.symbol
      : "",
    symbol: data.currentUser.currency.symbol,
    symbolFirst: data.currentUser.currency.symbolFirst,
    name: data.currentUser.currency.name,
    isoCode: data.currentUser.currency.isoCode,
    thousandsSeparator: data.currentUser.currency.thousandsSeparator,
    decimalMark: data.currentUser.currency.decimalMark,
    exponent: data.currentUser.currency.exponent,
  };
};
